import { carouselData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CarouselSection() {
  const ref = useScrollReveal();
  return (
    <section id="carousel" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            专题推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            精心策划的影视专题，发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap gap-5 justify-center">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-accent-300/60 transition-all duration-300"
              style={{ width: '100%', maxWidth: '380px', flex: '1 1 340px' }}
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}